import { Text } from '@belong/ui';
import { BLOG_CONTENT_STRINGS } from '../../blog.strings';
import { ContentTableItems } from '../content-table-items/content-table-items';
import type { ContentTableItem } from '../content-table-items/content-table-items';

type Props = {
  tableOfContents: ContentTableItem[];
};

export function ContentTable({ tableOfContents }: Props) {
  return (
    <div
      className="rounded-small border-gray border border-solid"
      style={{ width: '350px' }}
    >
      <div className="px-md py-sm">
        <Text fontWeight="semibold">{BLOG_CONTENT_STRINGS.tableContents}</Text>
      </div>
      <div className="border-gray bg-light-gray p-sm pl-xl border-0 border-t border-solid">
        <ContentTableItems items={tableOfContents} />
      </div>
    </div>
  );
}
